import { ReactElement } from 'react';
import { Stack } from '@mui/material';

import { PlanFeaturesTypes } from '~globals/types/enums';
import AccessFeature from '~components/AccessFeature';

import ReportsUserSatifactionSectionContextProvider from './Context';
import ReportsDownloadUserSatifactionFilters from './Filters';
import ReportsDownloadUserSatifactionContent from './Content';

const ReportsDownloadUserSatifaction = (): ReactElement => (
  <ReportsUserSatifactionSectionContextProvider>
    <Stack spacing={2} flex={1} height="100%">
      <AccessFeature.Alert
        validFeature={PlanFeaturesTypes.ReportCustomSatisfaction}
      />

      <AccessFeature.Hidden
        validFeature={PlanFeaturesTypes.ReportCustomSatisfaction}
        type="notAccess"
      >
        <>
          <ReportsDownloadUserSatifactionFilters />

          <ReportsDownloadUserSatifactionContent />
        </>
      </AccessFeature.Hidden>
    </Stack>
  </ReportsUserSatifactionSectionContextProvider>
);

export default ReportsDownloadUserSatifaction;
